<template>
  <div class="center-wrap">
    <header class="header">
      <div style="width: 1200px;display: flex;justify-content: space-between">
        <div class="logo" @click="$router.push('/home')">
          <div class="img">
            <!--          <img :src="require('@/assets/images/home/logo-gu.png')" style="border-radius: 40px" height="40" />-->
            <img :src="require('@/assets/layoutHome/header-logo.png')" height="40" />
          </div>
          <!--        <div class="txt">鼓教通</div>-->
        </div>
        <div class="user">
          <div class="photo">
            <img :src="avatarPhoto" width="36" height="36" v-if="avatarPhoto" />
            <img v-else :src="require('@/assets/img/center/neutral.png')" width="36" height="36" />
          </div>
          <div class="user-menu">
            <el-dropdown @command="handleCommand" placement="top-end">
              <span v-if="hasChildAccount && mainAccountInfo" class="el-dropdown-link" style="color: white;font-size: 20px">
                {{ mainAccountInfo.nickName + '-' }} <div style="display: inline-block;font-size: 16px;">{{ name + '(孩子)' }}</div><i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <span v-else class="el-dropdown-link" style="color: white;font-size: 20px">
                {{ name }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="home">门户首页</el-dropdown-item>
                <el-dropdown-item command="switch">切换机构/角色</el-dropdown-item>
                <el-dropdown-item command="switchUser">切换用户</el-dropdown-item>
<!--                <el-dropdown-item command="switchChild" v-if="hasChildAccount">切换孩子</el-dropdown-item>-->
                <el-dropdown-item command="logout">退出</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>

    </header>
    <selRoleLogin :open.sync=selRoleLoginVisible switch-mode="all" @roleLoginClose="selRoleLoginVisible = false">
    </selRoleLogin>
    <!--  手机号选择切换用户  -->
    <UserSelectDialog confirmText="切 换" :visible.sync="userVisible" :user-list="userList" @submit="handleUserSelect"
      @closed="handleClose" />
    <ChildSelectDialog confirmText="切 换" :visible.sync="childVisible" :child-list="childList"
      @submit="handleChildSelect" @closed="handleChildDialogClose" />
    <div class="main-con">
      <div class="left-side">
        <div class="user-info">
          <div class="photo">
            <img :src="avatarPhoto" width="100%" height="100%" v-if="avatarPhoto" />
            <img width="100%" height="100%" :src="photo" v-else />
          </div>

          <div class="name" v-if="hasChildAccount && mainAccountInfo">{{ mainAccountInfo.nickName || name }}</div>
          <div class="name" v-else>{{ name }}</div>
        </div>
        <el-menu mode="vertical" class="el-menu-vertical-demo" :default-openeds="openeds" :default-active="curMenu"
          router>
          <!-- :default-active="curMenu" -->
          <!--<el-menu-item index="/myApp">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              fill="none"
              version="1.1"
              width="20"
              height="20"
              viewBox="0 0 20 20"
            >
              <defs>
                <clipPath id="master_svg0_101_08700">
                  <rect x="0" y="0" width="20" height="20" rx="0" />
                </clipPath>
                <clipPath id="master_svg1_101_08701">
                  <rect x="0" y="0" width="20" height="20" rx="0" />
                </clipPath>
                <clipPath id="master_svg2_101_08702">
                  <rect x="0" y="0" width="20" height="20" rx="0" />
                </clipPath>
              </defs>
              <g clip-path="url(#master_svg0_101_08700)">
                <g clip-path="url(#master_svg1_101_08701)">
                  <g clip-path="url(#master_svg2_101_08702)">
                    <g>
                      <path
                        class="menu-icon"
                        d="M2.5,3.333333C2.5,2.8731,2.8731,2.5,3.333333,2.5L8.33333,2.5C8.79358,2.5,9.16667,2.8731,9.16667,3.333333L9.16667,8.33333C9.16667,8.79358,8.79358,9.16667,8.33333,9.16667L3.333333,9.16667C2.8731,9.16667,2.5,8.79358,2.5,8.33333L2.5,3.333333ZM2.5,11.66667C2.5,11.20642,2.8731,10.83333,3.333333,10.83333L8.33333,10.83333C8.79358,10.83333,9.16667,11.20642,9.16667,11.66667L9.16667,16.6667C9.16667,17.1269,8.79358,17.5,8.33333,17.5L3.333333,17.5C2.8731,17.5,2.5,17.1269,2.5,16.6667L2.5,11.66667ZM10.83333,3.333333C10.83333,2.8731,11.20642,2.5,11.66667,2.5L16.6667,2.5C17.1269,2.5,17.5,2.8731,17.5,3.333333L17.5,8.33333C17.5,8.79358,17.1269,9.16667,16.6667,9.16667L11.66667,9.16667C11.20642,9.16667,10.83333,8.79358,10.83333,8.33333L10.83333,3.333333ZM10.83333,11.66667C10.83333,11.20642,11.20642,10.83333,11.66667,10.83333L16.6667,10.83333C17.1269,10.83333,17.5,11.20642,17.5,11.66667L17.5,16.6667C17.5,17.1269,17.1269,17.5,16.6667,17.5L11.66667,17.5C11.20642,17.5,10.83333,17.1269,10.83333,16.6667L10.83333,11.66667ZM12.5,4.16667L12.5,7.5L15.8333,7.5L15.8333,4.16667L12.5,4.16667ZM12.5,12.5L12.5,15.8333L15.8333,15.8333L15.8333,12.5L12.5,12.5ZM4.16667,4.16667L4.16667,7.5L7.5,7.5L7.5,4.16667L4.16667,4.16667ZM4.16667,12.5L4.16667,15.8333L7.5,15.8333L7.5,12.5L4.16667,12.5Z"
                        fill-opacity="1"
                        style="mix-blend-mode: passthrough"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </svg>
            <span slot="title">我的应用</span>
          </el-menu-item>-->
          <el-menu-item index="/notice">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="none" version="1.1"
              width="20" height="20" viewBox="0 0 20 20">
              <defs>
                <clipPath id="master_svg0_101_08719">
                  <rect x="0" y="0" width="20" height="20" rx="0" />
                </clipPath>
              </defs>
              <g clip-path="url(#master_svg0_101_08719)">
                <g>
                  <path
                    d="M14.1667,1.66667L16.6667,1.66667C17.1269,1.66667,17.5,2.03976,17.5,2.5L17.5,17.5C17.5,17.9602,17.1269,18.3333,16.6667,18.3333L3.333333,18.3333C2.873096,18.3333,2.5,17.9602,2.5,17.5L2.5,2.5C2.5,2.03976,2.873096,1.66667,3.333333,1.66667L5.83333,1.66667L5.83333,0L7.5,0L7.5,1.66667L12.5,1.66667L12.5,0L14.1667,0L14.1667,1.66667ZM14.1667,3.33333L14.1667,5L12.5,5L12.5,3.33333L7.5,3.33333L7.5,5L5.83333,5L5.83333,3.33333L4.16667,3.33333L4.16667,16.6667L15.8333,16.6667L15.8333,3.33333L14.1667,3.33333ZM5.83333,6.66667L14.1667,6.66667L14.1667,8.33333L5.83333,8.33333L5.83333,6.66667ZM5.83333,10L14.1667,10L14.1667,11.6667L5.83333,11.6667L5.83333,10Z"
                    class="menu-icon" fill-opacity="1" />
                </g>
              </g>
            </svg>
            <span slot="title">通知公告<span class="no-read" v-if="newNotice > 0">{{
              newNotice
            }}</span></span>
          </el-menu-item>
          <el-menu-item index="/myClass" v-if="hasViewMyClassPermission">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="none" version="1.1"
              width="20" height="20" viewBox="0 0 20 20">
              <defs>
                <clipPath id="master_svg0_class_icon">
                  <rect x="0" y="0" width="20" height="20" rx="0" />
                </clipPath>
              </defs>
              <g clip-path="url(#master_svg0_class_icon)">
                <g>
                  <path
                    d="M5,14.5C5,13.1193,6.11929,12,7.5,12C8.88071,12,10,13.1193,10,14.5M10,14.5C10,13.1193,11.1193,12,12.5,12C13.8807,12,15,13.1193,15,14.5M4,4H16C16.5523,4,17,4.44772,17,5V10C17,10.5523,16.5523,11,16,11H4C3.44772,11,3,10.5523,3,10V5C3,4.44772,3.44772,4,4,4ZM7,7H13"
                    class="menu-icon" fill-opacity="1" />
                </g>
              </g>
            </svg>
            <span slot="title">我的班级</span>
          </el-menu-item>
          <el-menu-item index="/mySummary" v-if="hasViewSummaryPermission">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24">
              <path fill="currentColor"
                d="M3 3h18v18H3V3zm2 2v14h14V5H5zm2 2h10v2H7V7zm0 4h10v2H7v-2zm0 4h10v2H7v-2z" />
            </svg>
            <span slot="title">数据汇总</span>
          </el-menu-item>
          <el-submenu index="/message">
            <template slot="title">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="none"
                version="1.1" width="20" height="20" viewBox="0 0 20 20">
                <defs>
                  <clipPath id="master_svg0_101_08737">
                    <rect x="0" y="0" width="20" height="20" rx="0" />
                  </clipPath>
                </defs>
                <g clip-path="url(#master_svg0_101_08737)">
                  <g>
                    <path
                      d="M4.1373075,4.24669953125L7.0923075,14.58831953125L9.6256475,9.52169953125L14.3231875,7.64252953125L4.1373075,4.24669953125ZM2.4156455,1.91669593125L18.0872875,7.14002953125C18.2534875,7.19509953125,18.3674875,7.34814953125,18.3726875,7.52311953125C18.3778875,7.69807953125,18.2731875,7.85764953125,18.1106875,7.92252953125L10.8331475,10.83335953125L7.1456475,18.20831953125C7.0688475,18.36201953125,6.9055675,18.45281953125,6.7344675,18.43701953125C6.5633775,18.42111953125,6.4195575,18.30191953125,6.3723075,18.13671953125L1.8831453,2.42586253125C1.8407654,2.27711153125,1.8842712,2.11712353125,1.9961455,2.01031953125C2.1080195,1.90351438125,2.2698505,1.86746863125,2.4164785,1.91669593125L2.4156455,1.91669593125Z"
                      class="menu-icon" fill-opacity="1" />
                  </g>
                  <g
                    transform="matrix(0.5547001957893372,0.8320503830909729,-0.8320503234863281,0.5547001957893372,4.957908088063391,-3.110092903952207)">
                    <path
                      d="M13.851984426879882,3.8123567014312743L5.531671426879883,5.476421701431274L5.237497426879883,4.005548701431274L13.557814426879883,2.3414867014312746L13.851984426879882,3.8123567014312743Z"
                      fill-rule="evenodd" class="menu-icon" fill-opacity="1" />
                  </g>
                </g>
              </svg>
              <span>我的消息</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/message/message">消息列表<span class="no-read" v-if="newMessage > 0">{{
                newMessage
              }}</span></el-menu-item>
              <el-menu-item index="/message/task">待办任务<span class="no-read" v-if="newTask > 0">{{
                newTask
              }}</span></el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="/account">
            <template slot="title">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4z"></path>
                <path d="M18.36 19.78a6 6 0 1 0-12.72 0"></path>
                <path d="M22 12h-2"></path>
                <path d="M2 12h2"></path>
                <path d="M12 2v2"></path>
                <path d="M12 22v-2"></path>
                <path d="m17 7-1.5 1.5"></path>
                <path d="M7 17l-1.5 1.5"></path>
                <path d="m7 7 1.5 1.5"></path>
                <path d="M17 17l1.5 1.5"></path>
              </svg>
              <span>账户设置</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/account/info">个人信息</el-menu-item>
              <el-menu-item index="/account/set">账户设置</el-menu-item>
              <!--              <el-menu-item index="/account/editpwd">修改密码</el-menu-item>-->
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </div>
      <keep-alive>
        <div class="right-side">
          <router-view></router-view>
        </div>
      </keep-alive>
    </div>
    <Footer />
  </div>
</template>
<script>
import Footer from "./footer.vue";
import { getToken } from "@/utils/auth";
import { mapGetters } from "vuex";
import { checkUnRead } from "@/api/center/message";
import { checkNoticeUnRead } from "@/api/center/notice";
import selRoleLogin from "@/views/login/selRoleLogin.vue";
import UserSelectDialog from "@/views/components/UserSelectDialog.vue";
import ChildSelectDialog from "@/views/components/ChildSelectDialog.vue";
import { changeUser, getUsersByTel } from "@/api/login";
import {getChildListByToken} from '@/api/system/user'
import {transformParentChildData} from "@/utils/comm";

export default {
  name: "layoutCenter",
  components: { UserSelectDialog, selRoleLogin, Footer, ChildSelectDialog },
  props: {},
  data() {
    return {
      info: {},
      photo: require("@/assets/img/center/neutral.png"),
      curMenu: this.$route.path,
      openeds: ["/message", "/account"],
      storageDependency: 0, // 响应式变量，用于触发计算属性更新
      selRoleLoginVisible: false,
      hasViewMyClassPermission: false,
      hasViewSummaryPermission: false,
      selectedUser: "",  // 选择切换的用户
      userList: [], // 用户列表
      userVisible: false, // 用户选择对话框是否可见
      classWhiteList: ['老师'], // 我的班级模块 角色白名单
      summaryWhiteList: ['校长', '教导主任', '教育管理者'], // 数据汇总模块 角色白名单
      childList: [],
      childVisible: false,
    };
  },
  watch: {
    // 监听路由变化，更新当前激活的菜单项
    $route(to) {
      this.curMenu = to.path;
    },
  },
  computed: {
    hasTaken() {
      if (getToken()) {
        return true;
      } else {
        return false;
      }
    },
    ...mapGetters(["name", "avatar", "phonenumber", "hasChildAccount", "mainAccountInfo"]),
    avatarPhoto() {
      return this.avatar
        ? process.env.VUE_APP_BASE_API +
        "/system/File/downOssFile?uuid=" +
        this.avatar
        : null;
    },
    newMessage() {
      this.storageDependency; // 依赖storageDependency
      return localStorage.getItem("newMessage") || -1;
    },
    newNotice() {
      this.storageDependency; // 依赖storageDependency
      return localStorage.getItem("newNotice") || 0;
    },
    newTask() {
      this.storageDependency; // 依赖storageDependency
      return localStorage.getItem("newTask") || 0;
    },
  },
  created() {
    localStorage.setItem("newMessage", 0);
    localStorage.setItem("newTask", 0);
    localStorage.setItem("newNotice", 0);

    const whiteList = this.classWhiteList;
    const summaryWhiteList = this.summaryWhiteList;
    const loginRoleName = sessionStorage.getItem('loginRoleName') || '';
    const role = loginRoleName.split('-').pop(); // 提取出角色名
    const isWhiteListed = whiteList.includes(role);
    const isSummaryWhiteListed = summaryWhiteList.includes(role);
    // 判断是否是白名单内的角色
    if (isWhiteListed) {
      this.hasViewMyClassPermission = true;
    }
    if (isSummaryWhiteListed) {
      this.hasViewSummaryPermission = true;
    }

    checkUnRead({ source: "0" })
      .then((res) => {
        let unReadNum = res.data;
        checkNoticeUnRead({ status: "online" }).then((val) => {
          unReadNum = { ...unReadNum, newNotice: val.data };
          localStorage.setItem("newMessage", unReadNum.newMessage);
          localStorage.setItem("newTask", unReadNum.newTask);
          localStorage.setItem("newNotice", unReadNum.newNotice);
          // 触发计算属性更新
          this.storageDependency += 1;
        });
      })
      .catch((err) => {
      });
  },
  mounted() {
  },
  methods: {
    logout() {
      this.$confirm("确定要退出平台吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$store.dispatch("LogOut").then(() => {
          this.$router.push("/login");
          //location.href = "/";
        });
      });
    },
    handleCommand(command) {
      if (command == "logout") {
        this.logout();
      } else if (command == "switch") {
        if (this.hasChildAccount) {
          return this.$message({
            message: `当前暂无其他角色`,
            type: "warning",
            duration: 3000,
            showClose: true,
          })
        }

        if (this.$store.state.user.roleList.length === 1) {
          let loginRole = sessionStorage.getItem('loginRoleName') || this.$store.state.user.roleList[0]?.name;
          this.$message({
            message: `当前只有一个角色【${loginRole}】，无需切换！`, // 动态显示角色名称
            type: "warning",
            duration: 3000, // 提示显示时长
            showClose: true, // 显示关闭按钮
            iconClass: "el-icon-info", // 添加图标
          });
        } else {
          this.selRoleLoginVisible = true
        }
      } else if (command === "switchUser") {
        let testPhoneNumber = this.phonenumber
        if (this.hasChildAccount && this.mainAccountInfo) {
          testPhoneNumber = this.mainAccountInfo.phonenumber
        }
        // 获取用户是否有用户列表
        if (!testPhoneNumber || !(/^1[3-9]\d{9}$/.test(testPhoneNumber))) {
          return this.$message({
            message: "暂无其他账号！",
            type: "warning",
            duration: 3000, // 提示显示时长
            showClose: true, // 显示关闭按钮
            iconClass: "el-icon-info", // 添加图标
          });
        }
        getUsersByTel({ phoneNumber: testPhoneNumber }).then((phoneRes) => {
          if (phoneRes.code === 200) {
            const userList = transformParentChildData(phoneRes.data);

            if (userList.length > 1) {
              this.userList = userList;
              this.userVisible = true;
            } else {
              this.$message({
                message: "暂无其他账号！",
                type: "warning",
                duration: 3000, // 提示显示时长
                showClose: true, // 显示关闭按钮
                iconClass: "el-icon-info", // 添加图标
              });
            }
          }
        })
          .catch((error) => {
            console.log("getUsersByTel-error", error);
          });
      } else if (command === "switchChild") {
        this.getChildList();
      } else {
        this.$router.push("/" + command);
      }
    },
    handleClose() {
      this.resetSelectUser();
    },
    handleUserSelect(user) {
      this.selectedUser = user;

      let phoneNumber = this.phonenumber

      if (this.hasChildAccount && this.mainAccountInfo) {
        phoneNumber = this.mainAccountInfo.phonenumber
      }

      // 切换用户实现
      let changeUserRequestBody = {
        userName: this.selectedUser.userName,
        studentUserId: this.selectedUser.childId || null,
        phoneNumber: phoneNumber
      }

      const loading = this.$loading({
        lock: true,
        text: '切换中~',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.$store
        .dispatch("reLoginUser", changeUserRequestBody)
        .then(() => {
          // 显示提示
          this.$message({
            message: "切换用户成功！",
            type: "success",
            duration: 1500, // 提示显示时长
            showClose: true, // 显示关闭按钮
            iconClass: "el-icon-success", // 添加图标
          });
          // 刷新页面
          window.location.reload();
        })
        .catch(() => {
        })
        .finally(() => {
          loading.close();
        })
    },
    getChildList() {
      getChildListByToken().then((res) => {
        if (res.code === 200 && res.data.length > 1) {
          this.childList = res.data;
          this.childVisible = true;
        } else {
          this.$message({
            message: "暂无可切换的孩子！",
            type: "warning",
            duration: 3000,
            showClose: true,
            iconClass: "el-icon-info",
          });
        }
      });
    },
    handleChildSelect(child) {
      this.handleUserSelect(child);
      this.childVisible = false;
    },
    handleChildDialogClose() {
      this.childVisible = false;
    },
  },
};
</script>
<style scoped>
.center-wrap {
  background: #f2f3f5;
}

header {
  height: 64px;
  background: #076BF2A3;
  border-bottom: 1px solid #ebebeb;
  display: flex;
  /* padding: 0 80px 0 200px; */
  padding: 0 80px;
  align-items: center;
  justify-content: center;
  width: 100%;
  box-sizing: border-box;
  white-space: nowrap;
  box-shadow: 0 0 5px 0 #8b8b8b5f;
}

header .logo {
  display: flex;
  align-items: center;
  cursor: pointer;
}

header .logo .img {
  width: 40px;
  height: 40px;
  margin-right: 10px;
}

header .logo .txt {
  font-size: 18px;
  color: #101010;
  font-family: Source Han Sans;
  font-weight: 500;
}

.header .user {
  display: flex;
  align-items: center;
}

.header .user .photo {
  margin-right: 6.7px;
  width: 36px;
  height: 36px;
  border-radius: 12px;
  overflow: hidden;
}

.header .user>>>.el-dropdown {
  color: #333333;
}

.main-con {
  display: flex;
  justify-content: space-between;
  margin: 24px auto;
  background: #fff;
  width: 1200px;
}

.left-side {
  width: 272px;
  min-height: calc(100vh - 320px);
  border-right: 1px solid #dcdcdc;
  box-sizing: border-box;
  padding: 20px;
}

.right-side {
  flex: 1;
  border-left: 1px solid #dcdcdc;
  margin-left: -1px;
  padding: 18px 25px;
}

.user-info {
  margin: 8px 0;
  text-align: center;
}

.user-info .photo {
  width: 84px;
  height: 84px;
  opacity: 1;
  background: #c7e2ff;
  box-sizing: border-box;
  border: 2px solid #ffffff;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.08);
  border-radius: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  overflow: hidden;
}

.user-info .name {
  margin-top: 4px;
  font-size: 24px;
  line-height: 22px;
  color: #101010;
}

.left-side>>>.el-menu {
  border: none;
}

.left-side>>>.el-menu-item {
  padding: 0;
}

.el-menu>li span {
  margin-left: 18.5px;
}

.el-menu>li .el-menu-item-group .el-menu-item {
  padding-left: 58px !important;
}

.el-menu>li svg .menu-icon {
  fill: #333333;
}

.el-menu>li.is-active svg .menu-icon {
  fill: #076bf2;
}

.left-side>>>.el-menu .is-active .el-submenu__title {
  color: #076bf2;
}

.el-menu-item.is-active {
  font-weight: bold;
}

.left-side>>>.el-menu-item-group__title {
  padding: 0;
}

.no-read {
  display: inline-block;
  margin-left: 10px !important;
  padding: 0 10px;
  background: #f00;
  color: #fff;
  height: 14px;
  line-height: 14px;
  border-radius: 10px;
  font-weight: normal;
  font-size: 12px;
  position: absolute;
  top: 50%;
  transform: translateY(-55%);
}

.el-dropdown-menu {
  padding: 12px 0;
  text-align: center;
  min-width: 200px;
  line-height: 40px;
}

.el-dropdown-menu__item {
  font-size: 24px !important;
  padding: 12px 20px;
  margin: 12px 0 !important;
}

::v-deep .el-menu,
.el-menu-item {
  font-size: 18px;
}

::v-deep .el-submenu__title {
  font-size: 18px;
}
</style>
